import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Actions, Select, Store, ofActionSuccessful } from '@ngxs/store';
import { AuthContextState, GotoSignIn, SessionState, SignOut } from '@platform-frontend/account';
import { MobileScreenSizeDetector } from '@platform-frontend/checkout-drop-in';
import { PLATFORM_ENVIRONMENT, PLATFORM_MATOMO_EVENT_CATEGORY_FOOTER } from '@platform-frontend/platform';
import { Observable, filter, map, startWith, takeWhile, tap } from 'rxjs';
import { HostService } from '../../integration/iframe/host.service';

@UntilDestroy()
@Component({
  selector: 'yat-bottom-row',
  templateUrl: './bottom-row.component.html',
  styleUrls: ['./bottom-row.component.scss']
})
export class BottomRowComponent implements OnInit, OnDestroy {
  constructor(private hostService: HostService, private actions$: Actions, private store: Store, private translocoLocaleService: TranslocoLocaleService) {}

  @Input()
  accountInfoExpanded: boolean = false;

  @Select(SessionState.email)
  email$: Observable<string | null>;

  @Select(SessionState.isSignedIn)
  isSignedIn$: Observable<boolean>;

  readonly accountUrl$ = PLATFORM_ENVIRONMENT.accountUrl(this.translocoLocaleService.localeChanges$);
  isUmlLabHost: boolean;
  showWhatIsYattaHint$: Observable<boolean>;
  showDialog: boolean = false;

  readonly MATOMO_EVENT_CATEGORY_FOOTER = PLATFORM_MATOMO_EVENT_CATEGORY_FOOTER;

  ngOnInit(): void {
    this.isUmlLabHost = this.hostService.getVendorType() === 'UML_LAB';

    this.showWhatIsYattaHint$ = this.store.select(AuthContextState.authenticationContext).pipe(
      takeWhile(context => context !== 'SIGN_IN', true),
      map(context => context === 'SIGN_UP'),
      startWith(false)
    );

    this.actions$
      .pipe(
        ofActionSuccessful(GotoSignIn),
        filter(() => this.accountInfoExpanded),
        tap(() => this.expandAccountInformation()),
        untilDestroyed(this)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (this.showDialog || this.accountInfoExpanded) {
      const currentIsMobileScreenSize = this.isMobileScreenSize();

      if (currentIsMobileScreenSize && this.accountInfoExpanded) {
        this.accountInfoExpanded = false;
        this.showMobileDialog();
      }

      if (!currentIsMobileScreenSize && this.showDialog) {
        this.showDialog = false;
        this.accountInfoExpanded = true;
      }
    }
  }

  isMobileScreenSize(): boolean {
    return new MobileScreenSizeDetector().isMobileScreenSize();
  }

  closeMobileDialog(): void {
    this.showDialog = false;
  }

  showMobileDialog(): void {
    this.showDialog = true;
  }

  expandAccountInformation(): void {
    this.accountInfoExpanded = !this.accountInfoExpanded;
    if (this.accountInfoExpanded) {
      const inter = setInterval(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 1);
      setTimeout(() => {
        clearInterval(inter);
      }, 200);
    }
  }

  signOut(): void {
    this.showDialog = false;
    this.accountInfoExpanded = false;
    this.store.dispatch(new SignOut());
  }
}
